<!-- 修改礼品卡信息 -->
<template>
  <div class="updateGiftCard cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig">
      <template
        #pictureSlot="{
          rowData: {
            item,
            value: { PICTURE },
          },
        }"
      >
        <!-- <Poptip placement="right" :title="''" trigger="hover" popper-class="el-popover-img" transfer> -->
        <!-- 用于预览大图 -->
        <!--  + '?x-oss-process=image/quality,q_80' -->
        <el-image id="previewSrcList" v-show="false" class="avatar" fit="cover" :src="imageUrl" :preview-src-list="[imageUrl]"> </el-image>
        <div class="up__item-wrap" v-loading="imgLoading">
          <!-- 回显小图 -->
          <img class="up__item-thumbnail" v-show="imageUrl" :src="imageUrl" alt="" style="width: 100%; height: 100%; object-fit: cover" />
          <!-- hover时的遮罩层 -->
          <div class="up__item-actions" v-show="imageUrl">
            <span class="up__item-preview" :title="t('预览')">
              <i class="el-icon-zoom-in" v-on:click.self="handlePictureCardPreview()"></i>
            </span>
            <span class="up__item-delete" @click="handleDownload()" :title="t('下载')"><!-- 下载 -->
              <i class="el-icon-download"></i>
            </span>
            <span v-if="!disabled" class="up__item-delete" @click="handleUpdate()" :title="t('上传')">
              <i class="el-icon-upload2"></i>
            </span>
          </div>
          <!-- 用于上传 -->
          <div class="avatar-uploader" v-show="!imageUrl" @click="proImgChange">
            <div class="upload-div">
              <el-progress v-if="progressImg" type="circle" :percentage="progressImg" :width="60" :status="exception" />
              <i v-else class="el-icon-plus"></i>
            </div>
            <form role="form" method="POST" enctype="multipart/form-data" style="display: none">
              <div>
                <input :id="'upImgVm'" type="file" multiple="multiple" style="filter: alpha(opacity=0); opacity: 0; width: 0; height: 0; display: none" @change.stop="uploadFileChange($event)" />
              </div>
            </form>
          </div>
        </div>
        <!-- </Poptip> -->
      </template>
    </OmsForm>
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
const { network, urlSearchParams } = R3;
export default {
  name: 'updateGiftCard',
  props: {
    componentData: {},
  },
  watch: {
    componentData: {
      handler(newObj) {
        this.formConfig.formValue = Object.assign({}, this.formConfig.formValue, _.cloneDeep(newObj));
        this.imageUrl = newObj.PICTURE || '';
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    objId() {
      return 110 || this.$route.params.itemId;
    },
  },
  data() {
    return {
      exception: '',
      imgLoading: false,
      progressImg: 0,
      imageUrl: '',
      disabled: false,
      loading: false,
      btnConfig: {
        typeAll: 'default',
        btnsite: 'right',
        buttons: [
          {
            text: t('取消'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            },
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            btnclick: () => {
              this.datermine();
            }, // 按钮点击事件
          },
        ],
      },
      formConfig: {
        formValue: {
          TID: '',
          SENDER: '',
          RECEIVER: '',
          CONTENT: '',
          PICTURE: '',
        },
        formData: [
          {
            style: 'input',
            label: t('平台单号'), // 平台单号
            value: 'TID',
            width: '24',
            disabled: true,
          },
          {
            style: 'input',
            label: t('送礼人姓名'),
            value: 'SENDER',
            placeholder: t('请输入送礼人名称'),
            width: '24',
          },
          {
            style: 'input',
            label: t('收礼人姓名'),
            value: 'RECEIVER',
            placeholder: t('请输入收礼人名称'),
            width: '24',
          },
          {
            style: 'textarea',
            class: 'CONTENT_VM',
            label: t('赠言'),
            value: 'CONTENT',
            width: '24',
            placeholder: t('请输入赠言'),
            maxlength: 256,
            clearable: true
          },
          {
            style: 'formCompile',
            slotName: 'pictureSlot',
            label: t('礼品卡图片'),
            value: 'PICTURE',
            width: '24',
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    uploadFileChange(event) {
      console.log('uploadFileChange::', event);
      this.imgLoading = true
      const value = event.target.files[0];
      // if (!value || !this.beforeAvatarUpload(value)) {
      //   return;
      // }
      const data = new FormData();
      const path = `OC_B_ORDER_GIFT_CARD/${this.objId}/`;
      data.append('file', value);
      data.append('path', path);
      network.post('/p/cs/upload2', data).then((res) => {
        if (res.data.code == 0) {
          this.imageUrl = res.data.data.Url;
          this.formConfig.formValue.PICTURE = this.imageUrl;
        }
        return;
        this.uploadProgress(res.data.data.UploadId, () => {
          this.$set(this.colorList[index], 'URL', res.data.data.Url);
          this.saveObj.IMAGE_SKU = JSON.stringify(this.colorList);
        });
      }, false).finally(()=> {
        setTimeout(() => {
          this.imgLoading = false
        }, 100);
      });
    },
    beforeAvatarUpload() {},
    proImgChange() {
      console.log('proImgChange::');
      const dom = document.getElementById(`upImgVm`);
      dom.click();
    },
    handleUpdate() {
      console.log('handleUpdate::');
      this.proImgChange();
    },
    handlePictureCardPreview(file) {
      console.log('handlePictureCardPreview::');
      $('#previewSrcList').trigger('click');
    },
    handleDownload() {
      console.log('handleDownload::');
      const download_file = {};
      if (typeof download_file.iframe === 'undefined') {
        const iframe = document.createElement('iframe');
        download_file.iframe = iframe;
        document.body.appendChild(download_file.iframe);
      }
      const src = this.imageUrl;
      download_file.iframe.src = src;
      download_file.iframe.style.display = 'none';
    },
    async datermine() {
      let params = {};
      for (const key in this.formConfig.formValue) {
        params[key.toLocaleLowerCase()] = this.formConfig.formValue[key];
      }
      this.loading = true;
      const url = this.componentData.from == 'add' ? '/api/cs/oc/oms/v1/addGiftCard' : '/api/cs/oc/oms/v1/updateGiftCard';
      const {
        data: { code, message },
      } = await this.service.common.publicUrlParams(url, params).catch(() => {
        this.loading = false;
      });
      this.loading = false;
      if (code === 0) {
        const tab = this.$parent.$parent.$parent.queryTab('OC_B_ORDER_GIFT_CARD')
        this.$parent.$parent.$parent.labelClick(tab); // 刷新子表
        this.$parent.$parent.closeConfirm();
        this.$Message.success(message);
      }
    },
  },
};
</script>

<style lang="less">
.updateGiftCard {
  .CONTENT_VM {
    textarea {
      min-height: 70px !important;
      overflow-y: auto !important;
      margin-bottom: 4px;
      font-size: 12px;
      line-height: 1.5 !important;
    }
  }
}
.up__item-wrap {
  width: 120px;
  height: 120px;
  position: relative;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  overflow: hidden;
  &:hover {
    .up__item-actions {
      display: flex;
    }
  }
  .up__item-actions {
    display: none;
    color: #fff;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    transform: translateY(-50%);
    justify-content: space-around;
    align-items: center;
  }
  .avatar-uploader {
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .el-icon-plus {
      font-size: 18px;
      color: #8c939d;
    }
  }
}
</style>
